import React from 'react';
import VoxelButtonGrid from '../../Buttons/VoxelButtonGrid';


export interface VoxelPanelActionsProps {
  align?: 'left' | 'right';
  gridCols?: string;
}

export const VoxelPanelActions: React.FC<VoxelPanelActionsProps> = ({
  children,
  align = 'right',
  gridCols = undefined,
}) => {
  if (gridCols) {
    return <div className={`grid ${gridCols} gap-4 w-full p-6`}>{children}</div>;
  }

  return (
    <div className={`px-6 pb-6`}>
      <VoxelButtonGrid align={align}>{children}</VoxelButtonGrid>
    </div>
  );
};

export default VoxelPanelActions;
